import { defineMessages } from 'react-intl';

export default defineMessages({
  resultsCountHeader: {
    id: 'frontbucket.search.sourceBrowser.resultsCountHeader',
    description: 'Source browser search results count message header',
    defaultMessage: '{resultsCount} code results in this repository.',
  },
  resultsInfoHeader: {
    id: 'frontbucket.search.sourceBrowser.resultsInfoHeader',
    description: 'Source browser search results info message header',
    defaultMessage:
      'To find results outside of this repository, use the global {codeSearchLink}',
  },
  codeSearchLinkLabel: {
    id: 'frontbucket.search.sourceBrowser.codeSearchLinkLabel',
    description:
      'Source browser search results advanced code search link label',
    defaultMessage: 'code search.',
  },
  loadingMessage: {
    id: 'frontbucket.search.sourceBrowser.loadingMessage',
    description: 'Source browser search results loading message',
    defaultMessage: 'Searching for code in this repository...',
  },
});
